import React from "react";

import sliderImg from "../../assets/images/slider/slider1.jpg";
import sliderImg1 from "../../assets/images/slider/slider2.jpg";
import sliderImg2 from "../../assets/images/slider/slider3.png";
import { Carousel } from "react-bootstrap";
import "../banner/banner.css";

// https://react-bootstrap.netlify.app/docs/components/carousel
const Banner = () => {
  return (
    <section className="slider">
      <Carousel variant="dark">
        <Carousel.Item>
          <img src={sliderImg} className="d-block w-100" alt="first slide" />

          <Carousel.Caption>
            <div className="slider_des">
              <h5 className="heading">
                Strategy & stories, <span>digitally driven</span>
              </h5>
              <p className="sub_text">
                Connecting brands to the world through strategy, storytelling,
                and smart technology.
              </p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img src={sliderImg1} className="d-block w-100" alt="second slide" />
          <Carousel.Caption>
            <div className="slider_des">
              <h5 className="heading">
                Digital impact through<span>cinematic intelligence</span>
              </h5>
              <p className="sub_text">
                We connect, convert, and captivate through digital, video, and
                intelligent tech solutions.
              </p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img src={sliderImg2} className="d-block w-100" alt="third slide" />
          <Carousel.Caption>
            <div className="slider_des">
              <h5 className="heading">
                Tech-driven video,<span>measurable growth</span>
              </h5>
              <p className="sub_text">
                Where digital marketing, video, and IT solutions power
                measurable growth.
              </p>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </section>
  );
};

export default Banner;
